import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const authHeader = () => {
  const tok = localStorage.getItem('token') || localStorage.getItem('access_token') || '';
  return tok ? { Authorization: `Bearer ${tok}` } : {};
};

// Batch-resolve RL/EL/WL lead identity for records that don't carry lead_*
// fields directly (messages, reviews). Returns { customers:{id:ident}, appointments:{id:ident} }.
export async function resolveLeadIdentities({ customerIds = [], appointmentIds = [] }) {
  const ids = (customerIds || []).filter(Boolean);
  const aids = (appointmentIds || []).filter(Boolean);
  if (!ids.length && !aids.length) return { customers: {}, appointments: {} };
  try {
    const { data } = await axios.post(
      `${API}/api/connect/leads/identity/batch`,
      { customer_ids: ids, appointment_ids: aids },
      { headers: authHeader() },
    );
    return data || { customers: {}, appointments: {} };
  } catch {
    return { customers: {}, appointments: {} };
  }
}
